import axiosInstance from "../axiosInstance"
import type {
  UserResponseDto,
  UpdateUserDto,
  UserListParams,
  UserListResponseDto,
  ToggleUserActiveDto,
} from "../types/user.types"

/**
 * User API Client
 * Direct API calls using axios instance
 */
export const userClient = {
  // Get user by ID (Admin only)
  getUserById: (id: string): Promise<UserResponseDto> => {
    return axiosInstance.get(`/users/${id}`)
  },

  // List users with filters (Admin only)
  getUsers: (params?: UserListParams): Promise<UserListResponseDto> => {
    return axiosInstance.get("/users", { params })
  },

  // Update user profile (Admin or user themselves)
  updateUser: (id: string, data: UpdateUserDto): Promise<UserResponseDto> => {
    return axiosInstance.put(`/users/${id}`, data)
  },

  // Toggle user active status (Admin only)
  toggleUserActive: (id: string, data: ToggleUserActiveDto): Promise<UserResponseDto> => {
    return axiosInstance.put(`/users/${id}`, data)
  },
}

